import React from 'react';
import { FiFacebook } from 'react-icons/fi';

import { FooterOverlay, Newsletter } from '../../components';
import { images } from '../../constants';

import './Footer.css';

const Footer = () => (
  <div className='app__footer section__padding'>

    <div className='app__footer-links'>
      <div className='app__footer-links_contact'>
        <h1 className='app__footer-headtext'>Contact Us</h1>
        <p className='p__opensans'>1302 Ruby St, Ellensburg, WA 98926</p>
        <p className='p__opensans'>Tel: 509-925-2272</p>
      </div>
      <div className='app__footer-links_logo'>
        <img src={images.gdlogo} alt='footer_logo'></img>
        <p className='p__opensans'>"The best way to find yourself is to lose yourself in the service of others."</p>
        <img src={images.spoon} alt='spoon' className='spoon__img' style={{ marginTop: 15 }}/>
        <div className='app__footer-links_icons'>
          <FiFacebook/>
        </div>
      </div>
      <div className='app__footer-links_work'>
        <h1 className='app__footer-headtext'>Working Hours</h1>
        <p className='p__opensans'>Tues - Fri: 11:00am - 9:00pm</p>
        <p className='p__opensans'>Saturday: Noon - 9:00pm</p>
        <p className='p__opensans'>Sunday & Monday: Closed</p>
      </div>
    </div>
    <div className='footer_copyright'>
      <p className='p__opensans'>2023 Golden Dragon. All Rights reserved.</p>
    </div>
  </div>
);

export default Footer;
